import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { apiConstant, documentStatus, documentUsageVal, txnTableColumns, txnTableFields, transactionTypesConst, securitiesTableFields, 
  transactionStatus } from '../../app/app-constant';
import { DatePipe } from '@angular/common';

@Injectable()
export class CommonService {

  _selectedItems: any;
  public uploadModalSub = new Subject<string>();
  _openDocData: any;
  public openDocSub = new Subject<string>();
  public pendingTxnSub = new Subject<string>();
  public uploadedTxnSub = new Subject<string>();
  public approvedTxnSub = new Subject<string>();
  public sellNewTxnSub = new Subject<string>();
  public sellPendingTxnSub = new Subject<string>();
  public sellApprovedTxnSub = new Subject<string>();
  public dashboardTxnSub = new Subject<string>();
  public holdingTxnSub = new Subject<string>();
  public verRejInitSub = new Subject<string>();
  public verRejVerifySub = new Subject<string>();
  _activeEditHolding: any;
  _verRejInitData: any;
  _verRejVerifyData: any;
  pageRoute = {};

  constructor(private datePipe: DatePipe) {
  }

  getUniqueCustomers(txns: any) {
    //console.log('getUniqueCustomers');
    //let customers: any = [...new Set(txns.map(item => item.customerName))];
    const customersUnique: any = {};
    const customers: any = [{ label: 'All Customers', value: null }];
    for(const obj of txns) {
      if(!customersUnique[obj.customerName]) {
        customersUnique[obj.customerName] = true;
        const custItem = {'label': obj.customerName, value: obj.customerName};
        customers.push(custItem);
      }
    }
    
    return customers;
  }

  dateFilter(txns, filterType) {
    const date = new Date();
    if(filterType == "DAYS") {
      const timeCheck = new Date(date.getTime() - (7 * 24 * 60 * 60 * 1000));
      return txns.filter(state => (new Date(state.txnDate.toString().replace('GMT ', 'GMT+')) > timeCheck));
    } else if(filterType == "MONTH") {
      const timeCheck = new Date(date.getTime() - (30 * 24 * 60 * 60 * 1000));
      return txns.filter(state => (new Date(state.txnDate.toString().replace('GMT ', 'GMT+')) > timeCheck));
    } else {
      return txns;
    }
    
  }

  dateFormat(date) {
    /* if(date.indexOf('-') > -1) {
      let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      return date.split(' ')[0].split('-')[2]+' '+months[date.split(' ')[0].split('-')[1]-1]+' '+date.split(' ')[0].split('-')[0];
    } else {
      return date.split(' ')[2]+' '+date.split(' ')[1]+' '+date.split(' ')[3];
    } */

    //let timezoneVal = new Date().getTimezoneOffset().toString();
    //let localeVal = 'en-US';
    return this.datePipe.transform(date, 'dd MMM y', '+0800');
  }

  getFormatedData(txns: any, custAuditors?: any) {
    const that = this;
    const txnData = txns.map(function(obj) {
      //let stateData = obj.state.data;
      const stateData = obj;
      stateData.backOfficeId = stateData.backOfficeId ? stateData.backOfficeId.substring(0, 13) : '';
      stateData.customerName = stateData.customer ? stateData.customer : '';
      stateData.formatedTxnDate = stateData.txnDate && stateData.txnDate != 'null' ? that.dateFormat(stateData.txnDate) : null;
      if(stateData.transactionType == transactionTypesConst.BUY) {
        stateData.certCount = {
          uploaded: stateData.attachedDocumentsIds.uploadedAttachedDocumentsIds.length,
          approved: stateData.attachedDocumentsIds.approvedAttachedDocumentsIds.length,
          rejected: stateData.attachedDocumentsIds.rejectedAttachedDocumentsIds.length,
          internal: stateData.attachedDocumentsIds.internalAttachedDocumentIds.length
        };
      } else {
        stateData.certCount = {
          toBeSold: stateData.attachedDocumentsIds.uploadedAttachedDocumentsIds.length,
          sold: stateData.attachedDocumentsIds.approvedAttachedDocumentsIds.length,
          rejected: stateData.attachedDocumentsIds.rejectedAttachedDocumentsIds.length
        };
      }
      
      //stateData.attachedDocumentsArr = [];
      /* for(let key of Object.keys(stateData.attachedDocuments)) {
        stateData.attachedDocuments[key].formatedUploadDate = that.dateFormat(stateData.attachedDocuments[key].uploadDate);
        stateData.attachedDocuments[key].formatedUploadDate = stateData.attachedDocuments[key].uploadDate ? that.dateFormat(stateData.attachedDocuments[key].uploadDate) : '-';
        stateData.attachedDocuments[key].formatedDocVerificationDate = stateData.attachedDocuments[key].docVerificationDate && stateData.attachedDocuments[key].docVerificationDate != 'NA' ? that.dateFormat(stateData.attachedDocuments[key].docVerificationDate) : (stateData.attachedDocuments[key].docVerificationDate == 'NA' ? 'NA' : '-');
        stateData.attachedDocuments[key].formatedSellInitatedDate = stateData.attachedDocuments[key].sellInitatedDate ? that.dateFormat(stateData.attachedDocuments[key].sellInitatedDate) : '-';
        stateData.attachedDocuments[key].formatedSellVerifiedDate = stateData.attachedDocuments[key].sellVerifiedDate ? that.dateFormat(stateData.attachedDocuments[key].sellVerifiedDate) : '-';
        stateData.attachedDocuments[key].formatedSellInitiatedBy = stateData.attachedDocuments[key].sellInitiatedBy ? stateData.attachedDocuments[key].sellInitiatedBy : '-';
        stateData.attachedDocuments[key].formatedSellVerifiedBy = stateData.attachedDocuments[key].sellVerifiedBy ? stateData.attachedDocuments[key].sellVerifiedBy : '-';
        if(stateData.transactionType == "BUY") {
          if(stateData.attachedDocuments[key].documentStatus == documentStatus.UPLOADED) {
            stateData.certCount.uploaded++;
          } else if(stateData.attachedDocuments[key].documentStatus == documentStatus.APPROVED || stateData.attachedDocuments[key].documentStatus == documentStatus.SOLD || stateData.attachedDocuments[key].documentStatus == documentStatus.TOBESOLD) {
            stateData.certCount.approved++;
          } else if(stateData.attachedDocuments[key].documentStatus == documentStatus.REJECTED || stateData.attachedDocuments[key].documentStatus == documentStatus.REMOVED) {
            stateData.certCount.rejected++;
          } else if(stateData.attachedDocuments[key].documentStatus == documentStatus.TOBESOLD) {
            stateData.certCount.toBeSold++;
          } else if(stateData.attachedDocuments[key].documentStatus == documentStatus.SOLD) {
            stateData.certCount.sold++;
          }
        } else {
          if(stateData.attachedDocuments[key].documentStatus == documentStatus.TOBESOLD) {
            stateData.certCount.toBeSold++;
          } else if(stateData.attachedDocuments[key].documentStatus == documentStatus.SOLD) {
            stateData.certCount.sold++;
          } else if(stateData.attachedDocuments[key].documentStatus == documentStatus.REJECTED) {
            stateData.certCount.rejected++;
          }
        }
        stateData.attachedDocumentsArr.push(stateData.attachedDocuments[key]);
        stateData.attachedDocuments[key].faceAmount = stateData.attachedDocuments[key].documentUsage == documentUsageVal.EXTERNAL ? stateData.attachedDocuments[key].faceAmount.toFixed(2) : 'NA';
      } */
      
      //#AuditorRemove start
      /* if(custAuditors) {
        stateData.sharedWithCurrentAuditor = Object.keys(stateData.auditorsListTxnSharedWith).indexOf(custAuditors[stateData.customerName]) > -1 ? true : false;
      } */
      //#AuditorRemove end

      if(typeof stateData.linearId != "object") {
        stateData.linearId = {id: stateData.linearId};
      }

      //stateData.faceAmount = stateData.faceAmount.toFixed(2);

      return stateData;
    });

    return txnData;
  }

  getFormatedColData(cols: any, data: any) {
    const colsData = Object.assign([], cols);
    for(const col of colsData) {
      col.enabled = true;
      if(col.header == txnTableColumns.CLIENT) {
        col.filterType = "check-box";
        col.filterField = txnTableFields.CLIENT;
        col.uniqueValues = this.getUniqueValues(data, col);
        col.selectedValue = [];
      }

      if(col.header == txnTableColumns.ACCOUNT) {
        //col.filterType = "range";
        col.filterType = "check-box";
        col.filterField = txnTableFields.ACCOUNT;
        col.uniqueValues = this.getUniqueValues(data, col);
        //col.selectedValue = [0, 100000];
        col.selectedValue = [];
      }

      // if(col.header == txnTableColumns.ISSUER) {
      //   col.filterType = "check-box";
      //   col.filterField = txnTableFields.SECURITY_ID;
      //   col.uniqueValues = this.getUniqueValues(data, col);
      //   col.selectedValue = [];
      // }

      if(col.header == txnTableColumns.SECURITY_ID) {
        col.filterType = "check-box";
        col.filterField = txnTableFields.SECURITY_ID;
        col.uniqueValues = this.getUniqueValues(data, col);
        col.selectedValue = [];
      }

      if(col.header == txnTableColumns.PPN) {
        col.filterType = "check-box";
        col.filterField = txnTableFields.SECURITY_ID;
        col.uniqueValues = this.getUniqueValues(data, col);
        col.selectedValue = [];
      }

      if(col.header == txnTableColumns.DESCRIPTION) {
        //col.filterType = "string";
        col.filterType = "check-box";
        col.filterField = txnTableFields.SECURITY_ID;
        col.uniqueValues = this.getUniqueValues(data, col);
        //col.selectedValue = '';
        col.selectedValue = [];
      }

     /*  if(col.header == txnTableColumns.HSS_TXN_ID || col.header == txnTableColumns.DV_TXN_ID) {
        
      } */

      if(col.header == txnTableColumns.TXN_DATE) {
        col.filterType = "date";
        col.filterField = txnTableFields.TXN_DATE;
        col.selectedValue = {};
      }

      if(col.header == txnTableColumns.AMOUNT_QUANTITY) {
        col.filterType = "range";
        col.filterField = txnTableFields.AMOUNT_QUANTITY;
        const largestFaceAmount = this.getLargestFaceAmount(data);
        col.selectedValue = [0, largestFaceAmount];
        col.originalValues = [0, largestFaceAmount];
      }

      if(col.header == txnTableColumns.CURRENCY) {
        col.filterType = "check-box";
        col.filterField = txnTableFields.CURRENCY;
        col.uniqueValues = this.getUniqueValues(data, col);
        col.selectedValue = [];
      }

      if(col.header == txnTableColumns.LOCATION) {
        col.filterType = "check-box";
        col.filterField = txnTableFields.LOCATION;
        col.uniqueValues = this.getUniqueValues(data, col);
        col.selectedValue = [];
      }

      if(col.header == txnTableColumns.SECURITY_TYPE) {
        col.filterType = "check-box";
        col.filterField = securitiesTableFields.SECURITY_TYPE;
        col.uniqueValues = this.getUniqueValues(data, col);
        col.selectedValue = [];
      }

      if(col.header == txnTableColumns.SECURITY_QTY_TYPE) {
        col.filterType = "check-box";
        col.filterField = securitiesTableFields.SECURITY_QTY_TYPE;
        col.uniqueValues = this.getUniqueValues(data, col);
        col.selectedValue = [];
      }

      if(col.header == txnTableColumns.TRADED_MARKET) {
        col.filterType = "check-box";
        col.filterField = securitiesTableFields.TRADED_MARKET;
        col.uniqueValues = this.getUniqueValues(data, col);
        col.selectedValue = [];
      }
    }

    return colsData;
  }

  getBackendFormatedColData(cols: any, uniqueData: any, recordType = 'TXN') {
    const colsData = Object.assign([], cols);
    for(const col of colsData) {
      col.enabled = true;
      col.filterType = '';
      col.uniqueValues = [];
      for(const data of uniqueData) {
        if(col.field == data.field) {
          if(col.header == txnTableColumns.CLIENT) {
            col.filterType = "check-box";
            col.filterField = txnTableFields.CLIENT;
            col.uniqueValues = data.uniqueValues;
            col.selectedValue = [];
          }
          
          if(col.header == txnTableColumns.ACCOUNT) {
            col.filterType = "check-box";
            col.filterField = txnTableFields.ACCOUNT;
            col.uniqueValues = data.uniqueValues;
            col.selectedValue = [];
          }

          // if(col.header == txnTableColumns.ISSUER) {
          //   col.filterType = "check-box";
          //   col.filterField = recordType == 'TXN' ? txnTableFields.LOCAL_SECURITY_ID : txnTableFields.ISSUER;
          //   col.uniqueValues = data.uniqueValues;
          //   col.selectedValue = [];
          // }

          if(col.header == txnTableColumns.SECURITY_ID) {
            col.filterType = "check-box";
            col.filterField = txnTableFields.LOCAL_SECURITY_ID;
            col.uniqueValues = data.uniqueValues;
            col.selectedValue = [];
          }

          if(col.header == txnTableColumns.PPN) {
            col.filterType = "check-box";
            col.filterField = recordType == 'TXN' ? txnTableFields.LOCAL_SECURITY_ID : txnTableFields.PPN;
            col.uniqueValues = data.uniqueValues;
            col.selectedValue = [];
          }

          if(col.header == txnTableColumns.DESCRIPTION) {
            col.filterType = "check-box";
            col.filterField = recordType == 'TXN' ? txnTableFields.LOCAL_SECURITY_ID : txnTableFields.DESCRIPTION;
            col.uniqueValues = data.uniqueValues;
            col.selectedValue = [];
          }

          if(col.header == txnTableColumns.CURRENCY) {
            col.filterType = "check-box";
            col.filterField = txnTableFields.CCY;
            col.uniqueValues = data.uniqueValues;
            col.selectedValue = [];
          }

          if(col.header == txnTableColumns.AMOUNT_QUANTITY) {
            col.filterType = "range";
            col.filterField = txnTableFields.AMOUNT_QUANTITY;
            //col.selectedValue = [0, 250000];
            //col.originalValues = [0, 250000];
            col.selectedValue = [data.minMaxValues.min, data.minMaxValues.max];
            col.originalValues = [data.minMaxValues.min, data.minMaxValues.max];
          }

          if(col.header == txnTableColumns.LOCATION) {
            col.filterType = "check-box";
            col.filterField = txnTableFields.LOCATION;
            col.uniqueValues = data.uniqueValues;
            col.selectedValue = [];
          }

          if(col.header == txnTableColumns.HSS_TXN_ID) {
            col.filterType = "check-box";
            col.filterField = txnTableFields.HSS_TXN_ID;
            col.uniqueValues = data.uniqueValues;
            col.selectedValue = [];
          }

          /* if(col.header == txnTableColumns.DV_TXN_ID) {

          } */

          if(col.header == txnTableColumns.SECURITY_TYPE) {
            col.filterType = "check-box";
            col.filterField = securitiesTableFields.SECURITY_TYPE;
            col.uniqueValues = data.uniqueValues;
            col.selectedValue = [];
          }
    
          if(col.header == txnTableColumns.SECURITY_QTY_TYPE) {
            col.filterType = "check-box";
            col.filterField = securitiesTableFields.SECURITY_QTY_TYPE;
            col.uniqueValues = data.uniqueValues;
            col.selectedValue = [];
          }
    
          if(col.header == txnTableColumns.TRADED_MARKET) {
            col.filterType = "check-box";
            col.filterField = securitiesTableFields.TRADED_MARKET;
            col.uniqueValues = data.uniqueValues;
            col.selectedValue = [];
          }
        }
      }
  
      if(col.header == txnTableColumns.TXN_DATE) {
        col.filterType = "date";
        col.filterField = txnTableFields.TXN_DATE;
        col.selectedValue = {};
      }
    }

    return colsData;
  }

  resetColData(cols: Array<any>) {
    let colData = Object.assign([], cols);
    for(let data of colData) {
        delete data.uniqueValues;
    }

    return colData;
  }

  getUniqueValues(data: any, col: any) {
    const uniqueValues = [];
    const uniqueCheckObj = {};
    for(const obj of data) {
      if(!uniqueCheckObj[obj[col.field]]) {
        uniqueCheckObj[obj[col.field]] = true;
        const uniqueObj = {fieldValue: obj[col.field], filterValue: obj[col.filterField]};
        uniqueValues.push(uniqueObj);
      }
    }

    return uniqueValues;
  }

  getLargestFaceAmount(data) {
    let largestFaceAmount = 0;
    for(const txnData of data) {
      largestFaceAmount = txnData.transactionFaceAmount >  largestFaceAmount ? txnData.transactionFaceAmount : largestFaceAmount;
    }

    return largestFaceAmount;
  }

  filterData(data: any, filterCriteria: any) {
    let rowData = Object.assign([], data);
    //console.log(rowData);
    for(const colFilter of filterCriteria) {
      if(colFilter.filterType && colFilter.selectedValue.length != 0 && 
        (colFilter.filterType != 'date' || (colFilter.filterType == 'date' && (colFilter.selectedValue.fromDate || colFilter.selectedValue.toDate))) && 
        (colFilter.filterType != 'range' || (colFilter.filterType == 'range' && !(colFilter.selectedValue[0] == colFilter.originalValues[0] && colFilter.selectedValue[1] == colFilter.originalValues[1])))) {
          //console.log(colFilter.header, colFilter.selectedValue);
          if(colFilter.filterType == 'check-box') {
            rowData = rowData.filter(function(data) {
              const filterValues = colFilter.selectedValue.map(obj => obj.filterValue);
              if(filterValues.indexOf(data[colFilter.filterField]) > -1) {
                return true;
              }
            });
          }

          if(colFilter.filterType == 'range') {
            rowData = rowData.filter(function(data) {
              //console.log(colFilter.selectedValue, data[colFilter.field]);
              if(colFilter.selectedValue[0] <= data[colFilter.field] &&  data[colFilter.field] <= colFilter.selectedValue[1]) {
                return true;
              }
            });
          }

          if(colFilter.filterType == 'string') {
            rowData = rowData.filter(function(data) {
              //console.log(colFilter.selectedValue, data[colFilter.field]);
              if(data[colFilter.field].indexOf(colFilter.selectedValue) > -1) {
                return true;
              }
            });
          }

          if(colFilter.filterType == 'date') {
            rowData = rowData.filter(function(data) {
              //console.log(colFilter.selectedValue, data[colFilter.field]);
              if(new Date(colFilter.selectedValue.fromDate) <= new Date(data[colFilter.field]) && 
                new Date(data[colFilter.field]) <= new Date(colFilter.selectedValue.toDate)) {
                  return true;
                }
            });
          }
      }
    }
    //console.log(rowData);
    return rowData;
  }

  formatCertificateData(certData: any) {
    const attachedDocumentsArr = [];
    for(const data of certData) {
      data.formatedUploadDate = this.dateFormat(data.uploadDate);
      data.formatedUploadDate = data.uploadDate ? this.dateFormat(data.uploadDate) : '-';
      data.formatedDocVerificationDate = data.docVerificationDate && data.docVerificationDate != 'NA' ? this.dateFormat(data.docVerificationDate) : '-';
      data.formatedSellInitatedDate = data.sellInitiatedDate ? this.dateFormat(data.sellInitiatedDate) : '-';
      data.formatedSellVerifiedDate = data.sellVerifiedDate ? this.dateFormat(data.sellVerifiedDate) : '-';
      data.formatedSellInitiatedBy = data.sellInitiatedBy ? data.sellInitiatedBy : '-';
      data.formatedSellVerifiedBy = data.sellVerifiedBy ? data.sellVerifiedBy : '-';
      data.faceAmount = data.documentUsage == documentUsageVal.EXTERNAL ? data.faceAmount : '-';

      attachedDocumentsArr.push(data);
    }

    return attachedDocumentsArr;
  }

  getPaginationData(eventData: any) {
    const page = Math.floor(((eventData.first + 1) / (eventData.rows)) + 1);
    return {
        page: page,
        recordPerPage: eventData.rows,
        //sortField: eventData.sortField,
        //sortOrder: eventData.sortField
    };
  }

  getAppliedFilterData(cols: any) {
    const appliedFilter = [];
    for(const col of cols) {
      if(col.selectedValue && col.selectedValue.length != 0 && (col.filterType != 'date' || (col.filterType == 'date' && (col.selectedValue.fromDate || col.selectedValue.toDate))) && 
        (col.filterType != 'range' || (col.filterType == 'range' && !(col.selectedValue[0] == col.originalValues[0] && col.selectedValue[1] == col.originalValues[1])))) {
          appliedFilter.push(Object.assign({}, col));
          //console.log(col);
        }
    }

    return appliedFilter;
  }

  combineFilterData(columnFilter: any, appliedFilter: any, paginationData?: any, appliedSearch?: any) {
    for(const filterData of appliedFilter) {
      if(filterData.filterType == 'check-box') {
        columnFilter[filterData.filterField] = filterData.selectedValue.map(val => val.filterValue);
      } else if(filterData.filterType == 'date') {
        const fromDate = new Date(filterData.selectedValue.fromDate);
        //fromDate.setDate(fromDate.getDate() - 1);
        columnFilter.afterDate = fromDate.getTime();
        const toDate = new Date(filterData.selectedValue.toDate);
        //toDate.setDate(toDate.getDate() + 1);
        const nextDay = new Date(toDate.setDate(toDate.getDate() + 1));
        columnFilter.beforeDate = nextDay.getTime();
      } else if(filterData.filterType == 'range') {
        columnFilter.faceAmountFrom = filterData.selectedValue[0];
        columnFilter.faceAmountTo = filterData.selectedValue[1];
        columnFilter.holdingAmountFrom = filterData.selectedValue[0];
        columnFilter.holdingAmountTo = filterData.selectedValue[1];
      }
    }

    if(paginationData.sortField) {
      columnFilter.sortField = paginationData.sortField;
      columnFilter.sortOrder = paginationData.sortOrder;
    }

    if(appliedSearch) {
      const appliedSearchData = appliedSearch.split(': ');
      columnFilter['searchColumn'] = appliedSearchData[0];
      columnFilter['searchValue'] = appliedSearchData[1];
    }

    return columnFilter;
  }

  getSearchFilterData(event, lastSearchField) {
    const filterOptions = [];
    if(event.indexOf(': ') > -1) {
      if(lastSearchField != event.split(': ')[0]) {
          if(lastSearchField == 'ALL') {
              //this.dt.filterGlobal('', 'contains');
              filterOptions.push({filterGlobal: true, filterValue: ''});
          } else {
              //this.dt.filter('', lastSearchField, 'contains');
              filterOptions.push({filterGlobal: false, filterValue: '', filterColumn: lastSearchField});
          }
      }
      lastSearchField = event.split(': ')[0];
      if(event.split(': ')[0] == 'ALL') {
          //this.dt.filterGlobal(event.split(': ')[1], 'contains');
          filterOptions.push({filterGlobal: true, filterValue: event.split(': ')[1]});
      } else {
          //this.dt.filter(event.split(': ')[1], event.split(': ')[0], 'contains');
          filterOptions.push({filterGlobal: false, filterValue: event.split(': ')[1], filterColumn: lastSearchField});
      }
    } else {
        if(lastSearchField == 'ALL') {
            //this.dt.filterGlobal('', 'contains');
            filterOptions.push({filterGlobal: true, filterValue: ''});
        } else {
            //this.dt.filter('', lastSearchField, 'contains');
            filterOptions.push({filterGlobal: false, filterValue: '', filterColumn: lastSearchField});
        }
    }

    return {filterOptions: filterOptions, lastSearchField: lastSearchField};
  }

  formatExportTxnData(txnData: any) {
    let res = [];
    for(let data of txnData) {
      let obj = {
        "Account Number": data.accNumber,
        "Isin": data.isin,
        "Customer": data.customer.name.organisation,
        "HSS Txn ID": data.backOfficeId,
        "Currency": data.currency,
        "Transaction Face Amount": data.transactionFaceAmount,
        "Txn Date": this.dateFormat(data.txnDate),
        "Txn Type": data.transactionType,
        "Location Desc": data.locationDesc,
        "Txn Status": data.backOfficeTxnStatus,
        "Local Security Id": data.localSecurityId,
        "Stock Description": data.stockDescription,
        "Issuer": data.issuer,
        "ppn": data.ppn,
        "securityType": data.securityType,
        "securityQtyType": data.securityQtyType,
        "tradedMarket": data.tradedMarket,
        "Attached Cert Face Amount": data.attachedCertFaceAmount,
        "Sold Face Amount": data.soldFaceAmount,
        "Approved Documents Count": data.attachedDocumentsIds.approvedAttachedDocumentsIds.length,
        "Internal Document Count": data.attachedDocumentsIds.internalAttachedDocumentIds.length,
        "Rejected Documents Count": data.attachedDocumentsIds.rejectedAttachedDocumentsIds.length,
        "Uploaded Documents Count": data.attachedDocumentsIds.uploadedAttachedDocumentsIds.length,
      }
      res.push(obj);
    }

    return res;
  }
  
  formatExportFilterData(columnFilterData) {
    let res = [{}];
    for (var key in columnFilterData) {
      switch(key) {
        case 'transactionType':
          res[0]['Transaction Type'] = columnFilterData[key];
          break;
        case 'status':
          res[0]['Transaction Status'] = columnFilterData[key];
          break;
        case 'customerName':
          res[0]['Customer Name'] = columnFilterData[key].toString();
          break;
        case 'accNumber':
          res[0]['Account Number'] = columnFilterData[key].toString();
          break;
        case 'localSecurityId':
          res[0]['Local Security Id'] = columnFilterData[key].toString();
          break;
        case 'backOfficeId':
          res[0]['HSS Txn Id'] = columnFilterData[key].toString();
          break;
        case 'afterDate':
          res[0]['From Date'] = columnFilterData[key];
          break;
        case 'beforeDate':
          res[0]['To Date'] = columnFilterData[key];
          break;
        case 'currency':
          res[0]['Currency'] = columnFilterData[key];
          break;
        case 'locationDesc':
          res[0]['Location Desc'] = columnFilterData[key];
          break;
      }
    }
    
    return res;
  }

}
